import React, { useEffect, useState } from "react";
import "./PopupModal.css";
import useScapePressed from "../../functions/useScapePressed";

const PopupModal = ({ show, onClose, cards, zipCode, error }) => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  const scapePressed = useScapePressed();
  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };
    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  useEffect(() => {
    if (show && scapePressed) {
      onClose();
    }
  }, [scapePressed]);

  if (!show) return null;
  const toTitleCase = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  return (
    <div className="modal-overlay">
      <div className="modal-content agents-container">
        <button className="close-btn" onClick={onClose}>
          &times;
        </button>
        {cards.length > 0 ? (
          <div className="modal-header">
            <h2 className="modal-title">
              <span className="circle-count">{cards.length}</span>
              <span className="header-text" style={{ fontSize: "18px" }}>
                Agents Found Near {zipCode}
              </span>
            </h2>
          </div>
        ) : (
          <div className="modal-header">
            <h2 className="modal-title">
              <span className="header-text"> 0 Agents Found </span>
            </h2>
          </div>
        )}

        <div
          className={responsiveStatus ? "responsive-cards" : "card-grid"}
          style={{
            margin: "0 auto",
            maxWidth: "1000px",
            marginBottom: "1.5em",
          }}
        >
          {error ? (
            <div className="no-agents-message" style={{ fontWeight: "bold" }}>
              {error}
            </div>
          ) : (
            cards.map((card, index) => {
              const formattedPhone = (card.phone || "")
                .toString()
                .trim()
                .replace(/(\d{3})(\d{3})(\d{4})/, "($1)-$2-$3");

              const safeTrim = (val) => (val || "").toString().trim();

              return (
                <div
                  className="card"
                  key={index}
                  style={{
                    textAlign: "center",
                    marginBottom: responsiveStatus ? "15px" : "0",
                  }}
                >
                  <h5 style={{ fontSize: "18px", fontWeight: 600 }}>
                    {toTitleCase(safeTrim(card.agency_name))}
                  </h5>
                  <p style={{ marginTop: "10px" }}>
                    {safeTrim(card.address1)}, <br />
                    {safeTrim(card.city)}, {card.state}, {safeTrim(card.zip)}
                  </p>
                  <center>
                    <p style={{ marginTop: "10px" }}>
                      <a
                        href={`tel:${safeTrim(card.phone)}`}
                        className="agency-found-btn"
                        style={{ maxWidth: "150px" }}
                      >
                        <i className="fas fa-phone"></i> {formattedPhone}
                      </a>
                    </p>
                  </center>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
